export const Urls = {
    GetMySubscription: "customerSubscription/GetMySubscription",
    GetCustomerSubscription: "customerSubscription/GetCustomerSubscription",
    GetCustomerUnsubscribeSubscription: "customerSubscription/GetCustomerUnsubscribedSubscriptions",
    GetRuleCollection: "rule/GetRuleCollectionsForApi",
    CreateOrUpdateCustomerSubscription: "customerSubscription/CreateOrUpdateCustomerSubscription",
    CleanCustomerVessels: "customerSubscription/CleanCustomerVessels"
};
